const PENDING = 'PENDING';
const RUNNING = 'RUNNING';
const SUCCEEDED = 'SUCCEEDED';
const FAILED = 'FAILED';
const REJECTED = 'REJECTED';
const NOT_STARTED = 'NOT_STARTED';

export default {
    PENDING,
    RUNNING,
    SUCCEEDED,
    FAILED,
    REJECTED,
    NOT_STARTED,
};
